import { AT } from '../../../actions/actionTypes';
import {
  getStateFull,
  doAction,
  doEmptyAction,
} from '../../../core/redux/store';
import { State, DownloadHistory } from './model';
import { Panels } from '../model';
import { setRightPanel } from '../actions';
import * as MyKeysApiDownload from '../../../core/apis/mykeys/download';

import { ErrorDataResponse } from '../../../core/apis/mykeys/exceptions';
import { MyKeysPromiseMap } from '../../../core/apis/mykeys/mappings';
import { getOldestDate, getNewstDate } from '../../historical';
import Logger from '../../../libs/logger';  import { LogArea } from '../../../libs/logger/const';

const getState = (): State => getStateFull().dialogState.downloadLogsState;

export const openDialog = () => {
  Logger.info(['OpenDHistoryDialog']);
  setRightPanel(Panels.DEVICE_DOWNLOAD_LOGS);
};

export const getMoreLogs = () => {
  Logger.info(['getMoreLogs'], LogArea.Redux);
  const {historical} = getState();

  const lastLogDate = getOldestDate(historical.logs);
  MyKeysApiDownload.getDownloadLogs(undefined, lastLogDate)
    .then(MyKeysPromiseMap)
    .then((data: DownloadHistory) => {
      doAction<DownloadHistory>(AT.DIALOG_DOWNLOAD_MORELOGS_SUCCESS, data);
    })
    .catch((err: ErrorDataResponse) => {
      Logger.info([err]);
      doEmptyAction(AT.DIALOG_DOWNLOAD_MORELOGS_ERROR);
    });

  doEmptyAction(AT.DIALOG_DOWNLOAD_MORELOGS_FETCH);
};

export const getLatestLogs = () => {
  Logger.info(['getLatestLogs'], LogArea.Redux);
  const {historical} = getState();

  const firstLogDate = getNewstDate(historical.logs);
  MyKeysApiDownload.getDownloadLogs(firstLogDate)
    .then(MyKeysPromiseMap)
    .then((data: DownloadHistory) => {
      doAction<DownloadHistory>(AT.DIALOG_DOWNLOAD_LATESTLOGS_SUCCESS, data);
    })
    .catch((err: ErrorDataResponse) => {
      Logger.info([err]);
      doEmptyAction(AT.DIALOG_DOWNLOAD_LATESTLOGS_ERROR);
    });

  doEmptyAction(AT.DIALOG_DOWNLOAD_LATESTLOGS_FETCH);
};
